import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-hook-form';
import { SpecificDaysSchedulingForm } from '@/features/scheduling/components/SpecificDaysSchedulingForm';
import { EverydaySchedulingForm } from '@/features/scheduling/components/EverydaySchedulingForm';
import { SchedulingFormData } from '@/features/scheduling/types/SchedulingFormType.interface';

export type SchedulingFrequency = 'daily' | 'specific';

type Props = {
  control: Control<SchedulingFormData>;
  onFrequencyChange?: (frequency: SchedulingFrequency) => void;
  selectedFrequency: SchedulingFrequency;
};

export const EmaSchedulingEdition = ({
  control,
  onFrequencyChange,
  selectedFrequency,
}: Props) => {
  const { t } = useTranslation();

  const handleFrequencyChange = (frequency: SchedulingFrequency) => {
    onFrequencyChange?.(frequency);
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Button
          variant={selectedFrequency === 'daily' ? 'contained' : 'outlined'}
          size="large"
          onClick={() => handleFrequencyChange('daily')}
          sx={{ flex: 1, py: 2 }}
        >
          {t('pages.studies.emaQuestionnaire.scheduling.daily')}
        </Button>
        <Button
          variant={selectedFrequency === 'specific' ? 'contained' : 'outlined'}
          size="large"
          onClick={() => handleFrequencyChange('specific')}
          sx={{ flex: 1, py: 2 }}
        >
          {t('pages.studies.emaQuestionnaire.scheduling.specificDays')}
        </Button>
      </Box>

      {selectedFrequency === 'daily' && (
        <EverydaySchedulingForm control={control} />
      )}

      {selectedFrequency === 'specific' && (
        <SpecificDaysSchedulingForm control={control} />
      )}
    </>
  );
};
